<template>
  <div>
    <el-dialog
        :title="'Xuất file tổng hợp điểm danh'"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="10vh"
    >
      <el-form
          label-width="100px"
          :model="dataInput"
          label-position="left"
          :rules="rules"
          ref="dataInput"
      >
        <el-form-item label="Chọn ngày">
          <el-date-picker
              v-model="dateStartEnd"
              type="daterange"
              unlink-panels
              style="width: 300px"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              value-format="yyyy-MM-dd"
              format="dd-MM-yyyy"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="Chọn kiểu" style="width: 100%">
          <el-radio-group v-model="dataInput.type">
            <el-radio :label="true">Toàn bộ nhóm</el-radio>
            <el-radio :label="false">Theo nhóm</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="dataInput.type == false" label="Chọn nhóm" style="width: 100%">
          <el-select v-model="dataInput.idGroup" clearable placeholder="Chọn nhóm" style="width: 300px">
            <el-option
                v-for="(item,index) in kidGroupList"
                :key="index"
                :value="item.id"
                :label="item.nameGroup"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Trạng thái" prop="status">
          <!-- chọn trạng thái -->
          <el-select
              clearable
              style="width: 300px"
              class="button-left-status"
              v-model="dataInput.status"
              placeholder="Trạng thái"
          >
            <el-option
                v-for="item in kidStatusList"
                :key="item.key"
                :value="item.key"
                :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close" />
          <span>{{ $t("button.close") }}</span>
        </el-button>

        <el-button
            v-if="this.dateStartEnd.length == 0 || this.dataInput.status == null"
            type="success"
            size="medium"
            disabled
            :loading="loadingButton"
            mini
        >
          <i class="el-icon-circle-check" />
          <span>Xuất file</span>
        </el-button>

        <el-button
            v-else
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm()"
        >
          <i class="el-icon-circle-check" />
          <span>Xuất file</span>
        </el-button>
      </span>
    </el-dialog>
    <PeopleTypeCreate
        :dialogVisible="showCreateDialog"
        @dialog-close="dialogCloseCreateMethod()"
    />
  </div>
</template>

<script>
import {kidStatusList} from "@/constant/listCommon";
import PeopleTypeCreate from "@/views/cashinternal/PeopleTypeCreate.vue";
import shiftMaster from "@/services/ShiftMaster";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import {exportAttendanceSummaryV3MonthExcel} from "@/commonFuncion/exportAttendanceSummaryV3MonthExcel";

export default {
  components: {PeopleTypeCreate},
  props: {
    dialogVisible: null,
    targetType: {
      type: String,
      default: () => ""
    },
    teamType: {
      type: String,
      default: () => ""
    },
    kidGroupList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      kidStatusList,
      dateStartEnd: [],
      value1: [],
      textarea: "",
      typeInternalList: [],
      pickerOptions: {},
      selectDate: "",
      dataInput: {
        type: true,
        idGroup: "",
        status: "",
      },
      showCreateDialog: false,
      loadingButton: false,
      rules: {
        // status: [
        //   {
        //     required: true,
        //     message: "Trạng thái không được để trống",
        //     trigger: "blur",
        //   },
        // ],
      },
      //css excel
      styleCols1: [],
      styleCols2: [],
      nameCol: {
        name: "",
        style: "",
        numberMerges: 1,
      },
    };
  },
  
  methods: {
    submitForm() {
      if (this.dataInput.type == true) {
        this.dataInput.idGroup = "";
      }
      this.$confirm("Bạn có chắc chắn muốn xuất file không?", "Thông báo!", {
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        confirmButtonText: "Có",
        cancelButtonText: "Không",
      }).then(() => {
        const startDate = this.dateStartEnd?.[0] || null;
        const endDate   = this.dateStartEnd?.[1] || null;
        shiftMaster.getSummaryExel(
            this.dataInput.idGroup,
            this.$props.teamType,
            this.$props.targetType,
            startDate,
            endDate,
            this.dataInput.status
        )
            .then((resp) => {
              console.log(resp.data.data);
              exportAttendanceSummaryV3MonthExcel(resp.data.data, "STUDENT")
            })
            .catch((err) => {
              console.log(err);
              NotifyMessage.leftCornerNotificationError("Thất bại")
            });
      });
    },
    //Style css Excel
    getStyleExcel() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      this.nameCol.name = "Tổng cộng";
      this.nameCol.style = {
        fill: { fgColor: { rgb: "3399ff" } },
        font,
        border,
        alignment,
      };
      let style1 = {
        name: "A6:V7",
        style: {
          fill: { fgColor: { rgb: "f8eb00" } },
          font: font,
          alignment,
          border,
        },
      };
      //style1
      let styleCol1 = {
        name: "A5:B5",
        style: {
          fill: { fgColor: { rgb: "cfcfcf" } },
          font: { bold: true, sz: "11", color: { rgb: "f70000" } },
          alignment,
          border,
        },
      };
      let styleCol2 = {
        name: "C5:K1000",
        style: {
          fill: { fgColor: { rgb: "95cb4a" } },
          font,
          alignment,
          border,
        },
      };
      let styleCol01 = {
        name: ["A1"],
        style: {
          font: { color: { rgb: "ff0000" }, bold: true, sz: "18" },
        },
      };
      let styleCol02 = {
        name: ["A2", "A3", "A4"],
        style: {
          font: { bold: true, sz: "11" },
        },
      };

      this.styleCols2.push(styleCol1);
      this.styleCols2.push(styleCol2);
      this.styleCols2.push(style1);

      this.styleCols1.push(styleCol01);
      this.styleCols1.push(styleCol02);
    },
    createDialogMethod() {
      this.showCreateDialog = true;
    },
    dialogCloseCreateMethod() {
      this.showCreateDialog = false;
    },

    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.dateStartEnd = [];
        this.dataInput.status = "";
        this.dataInput.idGroup = "";
        this.dataInput.type = true;
      }, 300);
    },
  },

  // beforeMount() {
  //
  //   this.getCurrentDate();
  // },
};
</script>

<style lang="scss" scoped></style>
